// /app/frontend/src/components/ProfileDetailRow.jsx
//
// Tiny editorial detail row used in Discover detail and Profile views.
// Premium aesthetic: monochrome `--brand-blue` 14px lucide icon, then a
// kicker label, then the value. Designed to be scanned, not read.
//
//  <ProfileDetailRow icon={Briefcase} label="Work" value="Designer · Stripe" />

import React from 'react';

export const ProfileDetailRow = ({ icon: Icon, label, value, testId }) => {
  if (!value) return null;
  return (
    <div className="flex items-start gap-2.5" data-testid={testId}>
      {Icon && (
        <Icon
          size={14}
          strokeWidth={1.75}
          className="mt-[3px] shrink-0 text-[#0F0F10]"
          aria-hidden="true"
        />
      )}
      <div className="min-w-0">
        <p className="text-[10px] tracking-[0.15em] uppercase text-[#8A8A93] font-semibold mb-0.5">
          {label}
        </p>
        <p className="text-[#0F0F10] font-medium leading-snug break-words">
          {value}
        </p>
      </div>
    </div>
  );
};

export default ProfileDetailRow;
